export default __webpack_public_path__ + "static/media/globe-white.6383484c.svg";